import { type JSX, useState } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import {
  Outlet,
  RouterProvider,
  createRootRoute,
  createRouter,
} from "@tanstack/react-router";

import {
  type ClientRouterDataProps,
  clientRouterDataSchema,
} from "./ClientRouter.schema";
import { clientRoutes } from "./routes";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "client-router": { props: ClientRouterDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-client-router": HTMLElement;
  }
}

export function RWCClientRouter({
  basepath,
  filter,
}: ClientRouterDataProps): JSX.Element {
  // Built once: a router remade on every render would lose where it is.
  const [router] = useState(() => {
    const rootRoute = createRootRoute({ component: Outlet });

    return createRouter({
      routeTree: rootRoute.addChildren([clientRoutes(rootRoute, { filter })]),
      basepath,
      // Closing the editor goes back to the list, and its address is the page
      // itself rather than the page with a slash hanging off it.
      trailingSlash: "never",
    });
  });

  return <RouterProvider router={router} />;
}

componentManager.register(
  rwc("client-router", {
    component: RWCClientRouter,
    dataSchema: clientRouterDataSchema,
  }),
);
